import { PageContext } from './types'

// eslint-disable-next-line import/prefer-default-export
export const page404WithoutContext: PageContext = {
  name: '404',
  url: '/404',
  metaTitlePhrase: undefined,
  breadcrumbs: [
    {
      phrase: ['Common', 'breadcrumb.homepage.text'],
      url: '/'
    }
  ]
}
